export const subscriptionConstants = {
  // CREATE_SUBSCRIPTION_REQUEST: 'SUBSCRIPTION/CREATE_SUBSCRIPTION_REQUEST',
  // CREATE_SUBSCRIPTION_SUCCESS: 'SUBSCRIPTION/CREATE_SUBSCRIPTION_SUCCESS',
  // CREATE_SUBSCRIPTION_FAILURE: 'SUBSCRIPTION/CREATE_SUBSCRIPTION_FAILURE',

  CREATE_SUBSCRIPTION_AFTER_CHECKOUT_REQUEST: 'SUBSCRIPTION/CREATE_SUBSCRIPTION_AFTER_CHECKOUT_REQUEST',
  CREATE_SUBSCRIPTION_AFTER_CHECKOUT_SUCCESS: 'SUBSCRIPTION/CREATE_SUBSCRIPTION_AFTER_CHECKOUT_SUCCESS',
  CREATE_SUBSCRIPTION_AFTER_CHECKOUT_FAILURE: 'SUBSCRIPTION/CREATE_SUBSCRIPTION_AFTER_CHECKOUT_FAILURE',

  UPDATE_SUBSCRIPTION_AFTER_CHECKOUT_REQUEST: 'SUBSCRIPTION/UPDATE_SUBSCRIPTION_AFTER_CHECKOUT_REQUEST',
  UPDATE_SUBSCRIPTION_AFTER_CHECKOUT_SUCCESS: 'SUBSCRIPTION/UPDATE_SUBSCRIPTION_AFTER_CHECKOUT_SUCCESS',
  UPDATE_SUBSCRIPTION_AFTER_CHECKOUT_FAILURE: 'SUBSCRIPTION/UPDATE_SUBSCRIPTION_AFTER_CHECKOUT_FAILURE',

  // UPDATE_SUBSCRIPTION_REQUEST: 'SUBSCRIPTION/UPDATE_SUBSCRIPTION_REQUEST',
  // UPDATE_SUBSCRIPTION_SUCCESS: 'SUBSCRIPTION/UPDATE_SUBSCRIPTION_SUCCESS',
  // UPDATE_SUBSCRIPTION_FAILURE: 'SUBSCRIPTION/UPDATE_SUBSCRIPTION_FAILURE',

  GET_PLAN_UPDATE_LIST_REQUEST: 'SUBSCRIPTION/GET_PLAN_UPDATE_LIST_REQUEST',
  GET_PLAN_UPDATE_LIST_SUCCESS: 'SUBSCRIPTION/GET_PLAN_UPDATE_LIST_SUCCESS',
  GET_PLAN_UPDATE_LIST_FAILURE: 'SUBSCRIPTION/GET_PLAN_UPDATE_LIST_FAILURE',

  UPDATE_PLAN_REQUEST: 'SUBSCRIPTION/UPDATE_PLAN_REQUEST',
  UPDATE_PLAN_SUCCESS: 'SUBSCRIPTION/UPDATE_PLAN_SUCCESS',
  UPDATE_PLAN_FAILURE: 'SUBSCRIPTION/UPDATE_PLAN_FAILURE',

  UPDATE_PLAN_SIMPLE_REQUEST: 'SUBSCRIPTION/UPDATE_PLAN_SIMPLE_REQUEST',
  UPDATE_PLAN_SIMPLE_SUCCESS: 'SUBSCRIPTION/UPDATE_PLAN_SIMPLE_SUCCESS',
  UPDATE_PLAN_SIMPLE_FAILURE: 'SUBSCRIPTION/UPDATE_PLAN_SIMPLE_FAILURE',

  CANCEL_PENDING_PLAN_UPDATE_REQUEST: 'SUBSCRIPTION/CANCEL_PENDING_PLAN_UPDATE_REQUEST',
  CANCEL_PENDING_PLAN_UPDATE_SUCCESS: 'SUBSCRIPTION/CANCEL_PENDING_PLAN_UPDATE_SUCCESS',
  CANCEL_PENDING_PLAN_UPDATE_FAILURE: 'SUBSCRIPTION/CANCEL_PENDING_PLAN_UPDATE_FAILURE',

  GET_CURRENCY_REQUEST: 'SUBSCRIPTION/GET_CURRENCY_REQUEST',
  GET_CURRENCY_SUCCESS: 'SUBSCRIPTION/GET_CURRENCY_SUCCESS',
  GET_CURRENCY_FAILURE: 'SUBSCRIPTION/GET_CURRENCY_FAILURE',
}
